import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { PropertyService } from '../../properties/service/property.service';
import { CreateAmenityCategoryComponent } from '../create-amenity-category/create-amenity-category.component';
import { DialogModule } from 'primeng/dialog';
@Component({
  selector: 'app-amenity-category-listing',
  standalone: true,
  imports: [CommonModule, TableModule, ButtonModule, DialogModule, CreateAmenityCategoryComponent],
  templateUrl: './amenity-category-listing.component.html',
  styleUrls: ['./amenity-category-listing.component.scss'],
})
export class AmenityCategoryListingComponent {
  amenityCategories: any[] = []; 
  position: 'center' | 'right' = 'center';
  visible: boolean = false;

  showDialog(position: 'right'): void {
    this.position = position;
    this.visible = true;
  }

  constructor(private router: Router, private propertyService: PropertyService,) { }

  ngOnInit() {
    this.getAllAmenityCategories();
  }

  navigateToCreateAmenityCategory() {
    this.router.navigate(['/create-amenity-category']);
  }

  getAllAmenityCategories() {
    this.propertyService.getAmenityCategories().subscribe(res => {
      if (res) {
        this.amenityCategories = res;
      }
    });
  }
}
